<template>
  <div class="app-container tier-list">
    <basic-container class="tier-list-container">
      <avue-crud ref="crud"
                 :option="accountTierTableOption"
                 :data="tableData"
                 :table-loading="tableLoading"
                 @refresh-change="getAcountTierList"
                 @sort-change="handleSortChange">

        <template slot="menuLeft">
          <el-button
            v-if="permissions.tier_add"
            lass="filter-item"
            size="small"
            type="primary"
            @click="handleAdd"
            icon="el-icon-plus">
            新增
          </el-button>
        </template>

        <template slot="personalAvatarPreview" slot-scope="scope" >
          <div class="image-preview">
            <img class="anonymous-image" :src="anonymousImage">
            <img class="avatar-icon" v-if="scope.row.personalIcon" :src="scope.row.personalIcon">
            <img class="avatar-bgi" v-if="scope.row.personalBgi" :src="scope.row.personalBgi">
          </div>
        </template>
        <template slot="officialAvatarPreview" slot-scope="scope" >
          <div class="image-preview">
            <img class="anonymous-image" :src="anonymousImage">
            <img class="avatar-icon" v-if="scope.row.officialIcon" :src="scope.row.officialIcon">
            <img class="avatar-bgi" v-if="scope.row.officialBgi" :src="scope.row.officialBgi">
          </div>
        </template>

        <template slot="menu" slot-scope="scope">
          <el-button
            v-if="permissions.tier_edit"
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleEdit(scope.row, scope.index)">
            编辑
          </el-button>
          <el-button
            v-if="permissions.tier_delete"
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row, scope.index)">
            删除
          </el-button>
        </template>

      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { accountTierTableOption } from '@/const/crud/admin/member'
  import { fetchAccountTierList, deleteAccountTierByTierId } from '@/api/admin/tier'
  import anonymousImage from '@/static/images/member/anonymous.svg'

  export default {
    data () {
      return {
        tableData: [],
        addForm: undefined,
        accountTierTableOption,
        tableLoading: false,
        anonymousImage,
      }
    },
    computed: {
      ...mapGetters(['permissions']),
    },
    async created() {
      this.getAcountTierList()
    },
    activated() {
      this.getAcountTierList()
    },
    methods: {
      getAcountTierList() {
        this.tableLoading = true
        fetchAccountTierList().then(response => {
          this.tableData = this.formatData(response.data.data)
          this.tableLoading = false
        });
      },
      formatData(dataList) {
        let tempTableDatas=[]
        if (dataList && dataList.length > 0) {
          dataList.forEach(function(data, index) {
            let tempTableData ={}
            tempTableData.tierId = data.tierId
            tempTableData.personalName = data.personalName
            tempTableData.personalIcon = data.personalIcon
            tempTableData.personalBgi = data.personalBgi
            tempTableData.officialName = data.officialName
            tempTableData.officialIcon = data.officialIcon
            tempTableData.officialBgi = data.officialBgi
            tempTableDatas.push(tempTableData)
          })
        }
        return tempTableDatas
      },
      handleAdd() {
        this.$router.push({
          path: '/upms/member/tier/add'
        })
      },
      handleEdit(row) {
        this.$router.push({
          path: `/upms/member/tier/edit/${row.tierId}`
        })
      },
      handleDelete(row) {
        this.$confirm('确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteAccountTierByTierId(row.tierId).then(response => {
            if (response.data.data) {
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.getAcountTierList()
            }
          }).catch(error => {
            this.$message({
              message: error,
              type: 'error'
            })
          })
        }).catch(function (err) {
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
.image-preview {
  position:relative;
  margin-bottom: 15px;
  .anonymous-image{
    position:relative;
    width: 51px;
    height: 51px;
    top: 10px;
    border-radius: 6px;
    margin-right: 8px;
    float: center;
  }
  .avatar-icon {
    position:absolute;
    width: 15px;
    height: 15px;
    top: 48px;
    right: 60px;
    z-index: 2;
  }
  .avatar-bgi {
    position:absolute;
    width: 60px;
    height: 60px;
    top: 2px;
    right: 54px;
    z-index: 1;
  }
}
</style>